import React from "react";
import {connect} from 'dva';
import TempSelect from '../../pc/tempSelect';
import PcForm from '../../pc/form';
import List from '../../pc/list';
import ListDetail from '../../pc/listDetail';
import SubmitSuccess from '../../pc/submitSuccess';

function Content(props) {
    
    const { showType } = props;

    const renderItem = ()=> {
        if(showType === 0){
            return <TempSelect />
        }else if(showType === 1){
            return <PcForm />
        }else if(showType === 2){
            return <SubmitSuccess />
        }else if(showType === 3){
            return <List />
        }else if (showType === 4){
            return <ListDetail />
        }
    };

    return (
        <div className="zc-scroller">
            { renderItem() }
        </div>
    )
}

const mapState = state => {
    const { showType } = state.app;
    return { showType };
};

export default connect(mapState)(Content);